<template>
  <div class="magaya-location-modal">
    <b-overlay :show="loading" rounded="sm">
      <div class="create-account-modal">
        <div class="create-account-modal__header">
          <div class="create-account__title">
            <h3 class="create-account-modal__title">
              {{ $t("stopsInfo.createStopInfo.stopDetails") }}
            </h3>
          </div>
          <div class="create-account__button">
            <button @click="closeModal" class="close-button">
              <i class="ion ion-close-circle-outline close-button__icon"></i>
            </button>
          </div>
        </div>
        <hr />
        <span class="create-account-modal__subtitle">
          {{ $t("stopsInfo.createStopInfo.accountInformation") }}</span
        >
        <CreateAccountInputs :newAccountInfo="newAccountInfo" ref="account" />
        <hr />
        <span class="create-account-modal__subtitle">Contact Information</span>
        <ContactSearcher
          v-if="infoAccountModal"
          :contactsByAccount="contactsByAccount"
          :selectedAccount="infoAccountModal.account"
          ref="contact"
          v-model="newContactInfo"
        />
        <div class="checkbox-container">
          <b-form-checkbox
            v-model="newAccountInfo.createLocationInBd"
            id="checkbox"
            :binary="true"
            @click.stop
            @click.prevent
          />
          <label for="checkbox">
            <span>Save in My Locations</span>
          </label>
        </div>
        <button class="create-account-modal__button" @click="saveData()">
          {{ $t("stopsInfo.createStopInfo.save") }}
        </button>
      </div>
    </b-overlay>
  </div>
</template>

<script>
import CreateAccountInputs from "./CreateAccountInputs.vue";
import ContactSearcher from "../../shared/AccountCreation/ContactSearcher.vue";

export default {
  name: "MagayaLocationModal",
  props: { infoAccountModal: Object },
  components: {
    CreateAccountInputs,
    ContactSearcher,
  },
  data() {
    return {
      fieldsMissingAccount: false,
      fieldsMissingContact: false,
      newAccountInfo: {
        name: "",
        country_code: "US",
        city: "",
        state_code: "",
        zip_code: "",
        street: "",
        createLocationInBd: false,
      },
      newContactInfo: {
        first_name: "",
        last_name: "",
        phone: "",
        email: "",
      },
      loading: false,
      contactsByAccount: [],
    };
  },
  created() {
    if (this.infoAccountModal.account) {
      Object.keys(this.infoAccountModal.account).forEach((key) => {
        this.newAccountInfo[key] = this.infoAccountModal.account[key];
      });
    }
    this.getContactsByMagayaClient(this.infoAccountModal.account.guid);
  },
  methods: {
    async getContactsByMagayaClient(guid) {
      this.loading = true;
      this.contactsByAccount = await this.$store.dispatch("load/stops/getContactsByMagayaClient", {
        params: { guid },
      });
      this.loading = false;
    },
    async saveData() {
      const accountValidation = this.$refs.account.validateFormfields();
      const contactValidation = this.$refs.contact.validateForm();
      if (!accountValidation) {
        this.swal({
          title: `${this.$t("stopsInfo.createStopInfo.fieldsMissing")}`,
          text: "Please, try again.",
          icon: "error",
          dangerMode: true,
        });
      } else if (!contactValidation) {
        this.swal({
          title: `Missing fields`,
          text: "Please select a contact or fill the contact information.",
          icon: "error",
          dangerMode: true,
        });
      } else if (accountValidation && contactValidation) {
        this.loading = true;
        // Data for salesforce account
        const dataAccount = {
          name: this.newAccountInfo.name,
          street: this.newAccountInfo.street,
          city: this.newAccountInfo.city,
          zip_code: this.newAccountInfo.zip_code,
          country_code: this.newAccountInfo.country_code,
          state_code: this.newAccountInfo.state_code,
          createLocationInBd: this.newAccountInfo.createLocationInBd,
          //   // ONLY FOR TEST ACCOUNT
          account_id: process.env.VUE_APP_ACCOUNT_ID_TEST,
        };
        if (this.$options.filters.checkPermission("post:salesforce-account")) {
          const responseCreateAccount = await this.$store.dispatch(
            "load/stops/createSalesforceAccounts",
            dataAccount
          );
          const dataContact = {
            first_name: this.newContactInfo.first_name,
            last_name: this.newContactInfo.last_name,
            phone: this.newContactInfo.phone,
            email: this.newContactInfo.email,
            // ONLY FOR TEST ACCOUNT
            account_id: responseCreateAccount.id_salesforce,
          };
          if (this.$options.filters.checkPermission("post:salesforce-contact")) {
            const responseCreateContact = await this.$store.dispatch(
              "load/stops/createSalesforceContacts",
              dataContact
            );
            if (this.newAccountInfo.createLocationInBd) {
              this.$store.commit("load/stops/setNewSalesforceAccount", responseCreateAccount);
            }
            if (responseCreateAccount && responseCreateContact) {
              this.swal("Good job!", "Information created!", "success");
              const data = {
                account: responseCreateAccount,
                contact: responseCreateContact,
              };
              this.$emit("updateLocations", data);
            }
          }
        }
        this.closeModal();
        this.loading = false;
      }
    },
    closeModal() {
      this.$emit("closeModal");
      this.$emit("resetStopVariables");
    },
  },
};
</script>

<style lang="scss" scoped>
@use "../../../../assets/scss/components/Checkboxes.scss";
@use '@/assets/scss/_themes' as *;
@use '@/assets/scss/_variables' as *;
@use '@/assets/scss/_mixin' as *;
@use '@/assets/scss/_extend' as *;
@use '@/assets/scss/buttons/_buttons' as *;
.close-button {
  @include modals-close-button;
}
.create-account-modal {
  position: relative;
  background-color: $color-gray-light;
  border-radius: 10px;
  font-family: $font-family-portal;
  display: flex;
  flex-direction: column;
  justify-content: center;
  &__header {
    @include modals-header;
    width: 96%;
    margin: auto;
    justify-content: space-between;
  }
  &__subtitle {
    color: $color-border-container;
    font-weight: 600;
    text-align: left;
    @include font-standart-text;
    margin: 2%;
    margin-top: 0px;
  }
  &__button {
    @include primary-button($heightSize: 40px);
    @extend %flex-center-center;
    padding: 5px 20px;
    margin-top: 5%;
    width: 40%;
    border-radius: 13px;
    @include font-button-text;
    font-weight: 400;
    &:disabled {
      background-color: rgba(177, 177, 177, 0.774);
      &:hover {
        background-color: rgba(177, 177, 177, 0.774);
      }
    }
  }
}
.create-account__title {
  width: 95%;
  @include modals-title;
}
hr {
  width: 96%;
  margin: 0 auto 1rem auto;
}
.checkbox-container {
  width: 100%;
  display: flex;
  margin-left: 10px;
  align-items: center;
  @media (max-width: 991px) {
    margin: 0px;
  }
  @media (max-width: 500px) {
    margin-left: 5px;
  }
}
.checkbox-container label {
  margin: 0;
  margin-top: 5px;
  font-size: 0.98rem;
  vertical-align: middle;
  color: rgb(101, 100, 100);
}

::v-deep {
  .select-contact-modal {
    padding: 0px 12px;
    margin-bottom: 20px;
  }
  .contact-form {
    display: grid;
    grid-template-columns: 1fr 1fr;
    column-gap: 30px;
    &__email-content > div {
      margin-top: 0px;
    }
    &__information {
      margin-top: 20px;
      &--phone-number {
        margin-top: 0px;
      }
    }
    &__validation-phone {
      position: unset;
      text-align: right;
    }
  }
  .search-input__input {
    font-size: 1rem;
  }
}

::v-deep .spinner-border {
  color: $color-primary-company;
}

::v-deep .bg-light {
  background-color: $color-gray-light !important;
}

::v-deep {
  .p-inputtext,
  .dropdown-container__selected-option {
    padding-left: 1px !important;
  }
}
</style>
